import { render } from "./Android.vue?vue&type=template&id=195db42b&scoped=true"
import script from "./Android.vue?vue&type=script&lang=js"
export * from "./Android.vue?vue&type=script&lang=js"

import "./Android.vue?vue&type=style&index=0&id=195db42b&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195db42b"]])

export default __exports__